import { createFileRoute } from '@tanstack/react-router';
import { StockOnHandReport } from '../../../features/reports/screens/StockOnHandReport';

export interface StockOnHandSearch {
  productId?: string;
}

/** Owned by G25. Report #1 + register "stock on hand by location". Accepts an
 * optional `?productId=` deep link from global search (a PRODUCT match). */
export const Route = createFileRoute('/_authenticated/reports/stock-on-hand')({
  validateSearch: (search: Record<string, unknown>): StockOnHandSearch => ({
    productId: typeof search.productId === 'string' ? search.productId : undefined,
  }),
  component: StockOnHandRoute,
});

function StockOnHandRoute() {
  const { productId } = Route.useSearch();
  return <StockOnHandReport initialProductId={productId} />;
}
